import React from "react";
import lottie from "lottie-web";
import { useLocation } from "react-router-dom";

import { defineElement } from "@lordicon/element";
import { useSelector } from "react-redux";
export default function Footer() {
  defineElement(lottie.loadAnimation);
  const data = useSelector((state) => state.main.data?.mainData?.[0]);
  const location = useLocation();

  // Check if the current location is '/login'
  const isLoginPage = location.pathname === "/login";
  return (
    !isLoginPage && (
      <footer className="footer">
        <div className="head-title">تواصل معنا</div>
        <div className="container">
          <div className="group">
            <div className="logo">
              <img src="/images/logo.png" alt="" />
            </div>
            <div className="grouping">
              <div className="title">عيادة الدكتور</div>
              <div className="name">فادي محمود أبو فضة</div>
            </div>
          </div>
          <div className="group">
            <div className="section" data-aos="fade-right" data-aos-delay="">
              <div className="icon">
                {" "}
                <lord-icon
                  src="https://cdn.lordicon.com/tdtlrbly.json"
                  trigger="hover"
                  colors="primary:#ffffff,secondary:#ffffff"
                  target=".group .section"
                  style={{ width: "100%", height: "100%" }}
                ></lord-icon>
              </div>
              <div className="section-grouping">
                <div className="title">العنــوان</div>
                <div className="value">
                  بيت لحم، السينما، عمارة فريج الطابق الثاني، مقابل شركة
                  الكهرباء
                </div>
              </div>
            </div>
            <div className="section" data-aos="fade-right" data-aos-delay="300">
              <div className="icon">
                {" "}
                <lord-icon
                  src="https://cdn.lordicon.com/srsgifqc.json"
                  trigger="morph"
                  state="morph-phone-hang-up"
                  colors="primary:#fff"
                  target=".group .section"
                  style={{ width: "100%", height: "100%" }}
                ></lord-icon>
              </div>
              <div className="section-grouping">
                <div className="title">هاتف أرضي</div>
                <div className="value">{data?.landline}</div>
              </div>
            </div>
            <div className="section">
              <div className="icon">
                {" "}
                <lord-icon
                  src="https://cdn.lordicon.com/srsgifqc.json"
                  trigger="hover"
                  colors="primary:#fff"
                  target=".group .section"
                  style={{ width: "100%", height: "100%" }}
                ></lord-icon>
              </div>
              <div className="section-grouping">
                <div className="title">هاتف جوال</div>
                <div className="value">{data?.phone} </div>
              </div>
            </div>
          </div>
          <div className="group">
            <div className="copyright">
              <lord-icon
                src="https://cdn.lordicon.com/mpzsxzrz.json"
                trigger="hover"
                target=".copyright "
                colors="primary:#fff"
                style={{ width: "60px", height: "60px" }}
              ></lord-icon>
              <div className="grouping2">
                <div className="title">
                  <span>powered by 77 Group</span>
                </div>
                <div className="value">& Athar alfarasha</div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  );
}
